<script setup lang="ts">
interface Props {
  photoUrls: string[];
}
defineProps<Props>();
</script>

<template>
  <div v-if="photoUrls.length > 0" class="bg-surface border border-border rounded-lg p-4" data-testid="attachment-grid">
    <h3 class="text-caption font-semibold text-fg uppercase tracking-wide mb-3">
      Attachments ({{ photoUrls.length }})
    </h3>
    <!-- 4-col responsive grid per spec §2.2.2 -->
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
      <div
        v-for="(url, i) in photoUrls"
        :key="i"
        class="aspect-square rounded-md overflow-hidden bg-canvas-soft"
      >
        <!-- SAS URL endpoint is stub — render placeholder gradients per spec note -->
        <div
          v-if="!url || url.startsWith('placeholder')"
          :class="[
            'w-full h-full',
            i % 4 === 0 ? 'bg-gradient-to-br from-navy-100 to-navy-200' :
            i % 4 === 1 ? 'bg-gradient-to-br from-amber-100 to-amber-200' :
            i % 4 === 2 ? 'bg-gradient-to-br from-green-100 to-green-200' :
            'bg-gradient-to-br from-teal-100 to-teal-200',
          ]"
        />
        <img
          v-else
          :src="url"
          :alt="`Attachment ${i + 1}`"
          class="w-full h-full object-cover"
          loading="lazy"
        >
      </div>
    </div>
  </div>
</template>
